import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AppLayout } from "@/components/AppLayout";
import Marketing from "@/pages/Marketing";
import Auth from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Programs from "@/pages/Programs";
import ScannerHub from "@/pages/ScannerHub";
import Customers from "@/pages/Customers";
import Campaigns from "@/pages/Campaigns";
import Analytics from "@/pages/Analytics";
import Locations from "@/pages/Locations";
import Team from "@/pages/Team";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import SuperAdmin from "@/pages/SuperAdmin";
import AdminStaff from "@/pages/AdminStaff";
import SalesDesk from "@/pages/SalesDesk";
import BookingManage from "@/pages/BookingManage";
import PublicJoin from "@/pages/PublicJoin";
import StampAction from "@/pages/StampAction";
import Legal from "@/pages/Legal";
import ResetPassword from "@/pages/ResetPassword";
import NotFound from "@/pages/NotFound";

const A = (C) => <AppLayout><C /></AppLayout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" toastOptions={{ style: { borderRadius: 12, border: "1px solid #E8E5DE" } }} />
        <Routes>
          <Route path="/" element={<Marketing />} />
          <Route path="/login" element={<Auth />} />
          <Route path="/signup" element={<Navigate to="/login" replace />} />
          <Route path="/forgot-password" element={<Auth />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/join/:orgSlug/:programSlug" element={<PublicJoin />} />
          <Route path="/stamp/:token" element={<StampAction />} />
          <Route path="/booking/:token" element={<BookingManage />} />
          <Route path="/privacy" element={<Legal />} />
          <Route path="/terms" element={<Legal />} />
          <Route path="/app" element={A(Dashboard)} />
          <Route path="/app/programs" element={A(Programs)} />
          <Route path="/app/scanner" element={A(ScannerHub)} />
          <Route path="/app/customers" element={A(Customers)} />
          <Route path="/app/campaigns" element={A(Campaigns)} />
          <Route path="/app/analytics" element={A(Analytics)} />
          <Route path="/app/locations" element={A(Locations)} />
          <Route path="/app/team" element={A(Team)} />
          <Route path="/app/billing" element={A(Billing)} />
          <Route path="/app/settings" element={A(Settings)} />
          <Route path="/app/admin" element={A(SuperAdmin)} />
          <Route path="/app/admin/bookings" element={<Navigate to="/app/sales" replace />} />
          <Route path="/app/admin/staff" element={A(AdminStaff)} />
          <Route path="/app/sales" element={A(SalesDesk)} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
